import { postTime } from './localizedPostTime.js'

const ARBITRARILY_CHOSEN_LIMIT = 70

export default function getPostAltText(post, locale) {
  const postAltText = locale
    ? locale.getTranslation('postAltText')(post.userName, postTime(post.publishedAt, locale))
    : ''
  if (post.text && !post.isCarouselPost) {
    if (post.text.indexOf('#') !== 0) {
      let [text] = post.lines

      if (text.length <= ARBITRARILY_CHOSEN_LIMIT) {
        return `${postAltText}. ${text.trim()}`
      }

      const containsHashtags = text.indexOf('#') > 0

      if (containsHashtags) {
        text = text.split('#').shift()
      }

      if (text.length <= ARBITRARILY_CHOSEN_LIMIT) {
        return `${postAltText}. ${text.trim()}`
      }
    }
  }

  return postAltText
}
